import { render, staticRenderFns } from "./confirm-order.vue?vue&type=template&id=a2027200&scoped=true&"
import script from "./confirm-order.vue?vue&type=script&lang=js&"
export * from "./confirm-order.vue?vue&type=script&lang=js&"
import style0 from "./confirm-order.vue?vue&type=style&index=0&id=a2027200&prod&lang=scss&"
import style1 from "./confirm-order.vue?vue&type=style&index=1&id=a2027200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2027200",
  null
  
)

export default component.exports